import { fetchPostMultipleDeviationAsync } from '../fetch/deviationFetch';
import Swal from 'sweetalert2';
import { markMultipleOrdersAsReady } from '../pages/orders/OrdersUtil';

export const setMultipleOrderDeviation = async (selectedOrders: string[]) => {
  try {
    const response: Response = await markMultipleOrdersAsReady(
      selectedOrders,
      false
    );
    if (response.ok) {
      await fetchPostMultipleDeviationAsync(
        selectedOrders,
        'Denne pakken er ikke mottatt hos oss. - Porterbuddy',
        'OPEN'
      );
    } else {
      const acceptProblem = await Swal.fire({
        position: 'center',
        icon: 'error',
        title: `Orders can’t be marked as ready! Register deviation ${selectedOrders.join(
          ', '
        )} manually for these order IDs.
        This screen will refresh when you click OK.`,
        showConfirmButton: true,
      });
      if (acceptProblem.value) {
      }
    }
  } catch (error) {
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'There was an error, try again',
      showConfirmButton: false,
      timer: 1500,
    });
  }
};
